import * as React from 'react';
import { Store } from '../stores';
import { inject, observer } from 'mobx-react';
import { IAPanel } from '../../panels/Panel';
import { IATextField } from '../../textField/TextField';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAButton } from '../../button/Button';
import { IFeedStructureItem } from '../../../interfaces/IFeed';

export interface IProps {
  store?: Store;
  onClosePanel: () => void;
}

export interface IState {
  isCreatingOrUpdatingHeader: boolean;
  errorWhileUpdatingOrCreatingHeader: boolean;
}

@inject('store')
@observer
export class FeedStructureHeaderEditPanel extends React.Component<IProps, IState> {
  private readonly localizationService: LocalizationService = new LocalizationService();
  
  constructor(props: IProps) {
    super(props);
    this.state = {
      isCreatingOrUpdatingHeader: false,
      errorWhileUpdatingOrCreatingHeader: false
    }
  }

  private closePanel() {
    if (!this.state.isCreatingOrUpdatingHeader) {
      this.props.onClosePanel();
    }
  }

  private updateGroupHeaderTitle(newTitle: string, structure: IFeedStructureItem[]): IFeedStructureItem[] {
    if (structure.length > 0) {
      structure.forEach((feedStructureItem: IFeedStructureItem, index) => {
        if (feedStructureItem?.children?.length > 0) {
          feedStructureItem.children = this.updateGroupHeaderTitle(newTitle, feedStructureItem?.children)
        }
        if (feedStructureItem === this.props.store.headerToEdit) {
          structure[index].title = newTitle;
        }
      })
    }
    return structure;
  }

  public render(): JSX.Element {
    return <IAPanel
      close={() => this.closePanel()}
      open={!!this.props.store.headerToEdit}
      showNavigationBar
      transition="slide"
      width={600}
      footer={
        <IAButton
          label={this.localizationService.strings.Admin_Save}
          icon="Save"
          iconColor={"#ffffff"}
          textColor={"#ffffff"}
          borderRadius={5}
          disbaled={!this.props.store.headerToEdit?.title}
          buttonColor={this.props.store.highlightColor}
          showSpinner={this.state.isCreatingOrUpdatingHeader}
          onClick={() => {
            if (this.props.store.isAddingTopLevelGroupHeader) {
              this.props.store.structuredFeeds.push(this.props.store.headerToEdit);
            } else if (this.props.store.parentToAddHeaderTo) {
              if (this.props.store.parentToAddHeaderTo.children) {
                this.props.store.parentToAddHeaderTo.children.push(this.props.store.headerToEdit);
              } else {                
                this.props.store.parentToAddHeaderTo.children = [this.props.store.headerToEdit];
              }
              this.props.store.parentToAddHeaderTo = undefined;
            } else {
              this.updateGroupHeaderTitle(this.props.store.headerToEdit.title, this.props.store.structuredFeeds);
            }
            this.closePanel();
          }}
          style={{
            marginTop: 10,
            marginBottom: 10
          }}
        />
      }
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "0 40px"
        }}
      >
        <IATextField
          label={this.localizationService.strings.TargetingAdmin_UserGroup_EditPanel_Title}
          text={this.props.store.headerToEdit?.title}
          borderRadius={5}
          placeholder={this.localizationService.strings.TargetingAdmin_UserGroup_EditPanel_Title}
          highlightColor={this.props.store.highlightColor}
          onChange={(newTitle: string) => this.props.store.headerToEdit.title = newTitle}
          disabled={this.state.isCreatingOrUpdatingHeader}
        />
      </div>
    </IAPanel>
  }
}